import React from 'react'

import type { Header, PageMeta, PicksContent } from '../../generated/frontend'
import { useEnergyPageQuery } from '../../generated/frontend'
import { ErrorComponent, Loader, PageError } from '../../shared'
import { usePageProps } from '../../shared/usePageProps'
import { PageWrapperWithMeta } from '../../shared/wrappers/PageWrapperWithMeta'
import { Landing } from './components'
import { useEnergyMetaTags } from './hooks/useEnergyMetaTags'

const EnergyPage: React.FC = () => {
  const { rootCollectionName = '' } = usePageProps()
  const { loading, error, data } = useEnergyPageQuery({
    variables: { rootCollectionName },
  })
  const { getMetaTags } = useEnergyMetaTags()

  if (loading) {
    return <Loader />
  }

  if (error) {
    return <ErrorComponent error={error} />
  }

  if (!data) {
    return <PageError pageName="Which? energy" />
  }

  const { meta, contentItems, header, authors, relatedArticleLinks } = data.energyPage

  return (
    <PageWrapperWithMeta metaTags={getMetaTags(meta as PageMeta)}>
      <Landing
        contentItems={contentItems as PicksContent[]}
        header={header as Header}
        relatedArticleLinks={relatedArticleLinks}
        authors={authors}
      />
    </PageWrapperWithMeta>
  )
}

export default EnergyPage
